import React from 'react';

interface TwitterLogoProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const TwitterLogo: React.FC<TwitterLogoProps> = ({
  size = 50,
  color = '#066653',
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 50 50'
      fill={color}
      role='img'
      aria-labelledby='twitterLogoTitle'
      {...props}>
      <title id='twitterLogoTitle'>Twitter Logo</title>
      <path d='M 6.92 6 L 21.14 26.73 L 6.23 44 L 9.41 44 L 22.54 28.78 L 32.99 44 L 43 44 L 28.12 22.31 L 42.2 6 L 39.03 6 L 26.72 20.26 L 16.93 6 L 6.92 6 z'></path>
    </svg>
  );
};

export default TwitterLogo;
